import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=55a49957&scoped=true&lang=html"
import script from "./HowItWorks.vue?vue&type=script&lang=js"
export * from "./HowItWorks.vue?vue&type=script&lang=js"
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=55a49957&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a49957",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55a49957')) {
      api.createRecord('55a49957', component.options)
    } else {
      api.reload('55a49957', component.options)
    }
    module.hot.accept("./HowItWorks.vue?vue&type=template&id=55a49957&scoped=true&lang=html", function () {
      api.rerender('55a49957', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HowItWorks.vue"
export default component.exports